var _a;
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    id: "",
    status: "",
    readLater: false,
    subscribed: false,
};
export var userSlice = createSlice({
    name: "user",
    initialState: initialState,
    reducers: {
        setId: function (state, action) {
            state.id = action.payload;
        },
        setStatus: function (state, action) {
            state.status = action.payload;
        },
        setReadLater: function (state, action) {
            state.readLater = action.payload;
        },
        setSubscribed: function (state, action) {
            state.subscribed = action.payload;
        },
    },
});
export var setId = (_a = userSlice.actions, _a.setId), setStatus = _a.setStatus, setReadLater = _a.setReadLater, setSubscribed = _a.setSubscribed;
export var selectId = function (state) { return state.user.id; };
export var selectStatus = function (state) { return state.user.status; };
export var selectReadLater = function (state) { return state.user.readLater; };
export var selectSubscribed = function (state) { return state.user.subscribed; };
export default userSlice.reducer;
